<script setup lang="ts">
import {
  FieldNodePageFieldSidebarWidgets,
  ParagraphAnchors,
  MediaImageFragment,
  NodeCbzLandingPage,
  FieldNodePageFieldLead,
  ParagraphStickyEventTeaser,
} from '~/api/graphql/generated'
import { Link } from '~/types'

const props = defineProps<{
  entity: NodeCbzLandingPage
  breadcrumbs?: Link[]
}>()

const heroData = computed(() => ({
  content: {
    title: props.entity.title || '',
    subtitle: props.entity.fieldSubtitle || '',
  },
  logo: (props.entity.fieldLogo?.entity as MediaImageFragment) ?? undefined,
  back: props.entity.fieldOverviewLink
    ? {
        text: props.entity.fieldOverviewLink?.title || '',
        url: props.entity.fieldOverviewLink?.url?.path || '',
      }
    : undefined,
  image:
    props.entity.fieldMobileImage?.entity && props.entity.fieldImage?.entity
      ? {
          small: props.entity.fieldMobileImage?.entity as MediaImageFragment,
          large: props.entity.fieldImage?.entity as MediaImageFragment,
        }
      : undefined,
}))

const introText = computed(() => props.entity.fieldLead?.processed || '')

const footerData = computed(() => ({
  logo: props.entity.fieldFooterLogo?.entity as MediaImageFragment,
  address: props.entity.fieldFooterAddress?.processed || '',
  schedule: props.entity.fieldFooterSchedule?.processed || '',
  cta: props.entity.fieldFooterCta
    ? {
        text: props.entity.fieldFooterCta?.title || '',
        url: props.entity.fieldFooterCta?.url?.path || '',
      }
    : undefined,
  links:
    props.entity.fieldFooterLinks?.map((link) => ({
      text: link?.title || '',
      url: link?.url?.path || '',
    })) || [],
}))
</script>

<template>
  <main class="main">
    <CbzHero v-bind="heroData" />
    <SectionIntrotext v-if="introText" :text="introText" />
    <SectionAnchors v-if="entity.fieldAnchors?.entity" :entity="entity.fieldAnchors.entity as ParagraphAnchors" />
    <SectionSidebar :sidebar="entity.fieldSidebarWidgets as FieldNodePageFieldSidebarWidgets[]" />
    <SectionStickyEventTeaser :entity="entity?.fieldStickyEventTeaser?.entity as ParagraphStickyEventTeaser" />
    <Sections :entity="entity" />
  </main>

  <CbzFooter
    :logo="footerData.logo"
    :address="footerData.address"
    :schedule="footerData.schedule"
    :cta="footerData.cta"
    :links="footerData.links"
  />
</template>
<style scoped lang="scss">
.main {
  padding-top: 0;
}
</style>
